import { render, staticRenderFns } from "./Trace.vue?vue&type=template&id=6b32862d&scoped=true&"
import script from "./Trace.vue?vue&type=script&lang=js&"
export * from "./Trace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b32862d",
  null
  
)

export default component.exports